export type IconProps = React.SVGProps<SVGSVGElement>

const WarnIcon = ({ className, ...props }: IconProps) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" role="img" className={className} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.71692 2.73165L1.18578 15.8922C0.644334 16.8386 1.35118 18 2.46862 18H17.5314C18.6488 18 19.3557 16.8386 18.8142 15.8922L11.2826 2.73165C10.7241 1.75612 9.27539 1.75612 8.71692 2.73165ZM10.0003 6C10.5526 5.99994 11.0003 6.4476 11.0004 6.99989L11.0006 10.3471L11.0006 11.5364L11.0006 11.8778L11.0006 11.9687V11.9921L11.0006 11.998V11.9995V11.9999V12C11.0006 12 11.0006 12 10.0006 12L9.00057 11.9999V11.9998V11.9995V11.998L9.00057 11.992V11.9686L9.00057 11.8778L9.00058 11.5364L9.00058 10.3471L9.00041 7.00011C9.00034 6.44783 9.44801 6.00006 10.0003 6ZM10.0006 12L11.0006 12C11.0006 12.5523 10.5528 13 10.0005 13C9.44825 13 9.00055 12.5522 9.00057 12L10.0006 12ZM9 15C9 14.4477 9.44771 14 10 14C10.5523 14 11 14.4477 11 15C11 15.5523 10.5523 16 10 16C9.44771 16 9 15.5523 9 15Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default WarnIcon
